let locales = {
    permissionEdit_title: 'Crear Permiso',
    permissionEdit_titleEdit: 'Editar Permiso',
    permissionEdit_warningTitle: 'Advertencia: Los permisos creados deben de ser adaptados al código fuente para funcionar correctamente.'
};

export default locales;